export const RESTRICTION_TIME_MS = 300000;
export const ATTEMPTS_UPDATE_INTERVAL_MS = 300000;
export const MAX_ATTEMPTS = 3;
